function applyValidationProperties(multilineAddressOptions) {
  return (addressForms) => {
    if (multilineAddressOptions?.fields) {
      const propertiesByTarget = multilineAddressOptions.fields;
      const modifiedFields = addressForms.fields?.map(
        (field) => field.target ? overrideFieldValidation(
          field,
          propertiesByTarget[field.target]
        ) : field
      );
      return { ...addressForms, fields: modifiedFields };
    } else {
      return addressForms;
    }
  };
}
function overrideFieldValidation(field, fieldOverrides) {
  if (fieldOverrides && field.validation) {
    return {
      ...field,
      validation: {
        ...field.validation,
        required: fieldOverrides.required ?? field.validation.required
      }
    };
  } else {
    return field;
  }
}
export {
  applyValidationProperties
};
//# sourceMappingURL=apply-validation-properties.js.map
